import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import 'vuetify/dist/vuetify.min.css'
// import vi from '@/plugins/locale.vi.js'
import vi from '@/assets/i18n/vi'
import en from '@/assets/i18n/en'
import jp from '@/assets/i18n/jp'
Vue.use(Vuetify)

const opts = {
	theme: {
		// dark: true,
		themes: {
			light: {
				primary: '#255cc2',
				secondary: '#3c73d9',
				third: '#c8dbff',
				forth: '#01256b',
				anchor: '#8c9eff',
				error: '#ff0b16',
				success: '#00dd51',
				warning: '#ffc900',
				gray: '#cfcdd3',
				purple: '#5955de',
				pink: '#ff004f',
				orange: '#ff8f00',
				'drak-gray': '#908e95',
				'light-gray': '#f2f2f2',
				'dark-text':'#3E3E3C',
				'dark-grey': '#797979',
			}
		}
	},
	lang: {
		locales: {jp, en, vi},
		current: 'en'
	},
}

export default new Vuetify(opts)
export { opts }
